var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFleetRTcollapseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2A2D5110-6639-4475-92F3-AAE682D74191") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup-6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fleet--DashBoard-Collapse",
    transform: "translate(3.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(-3.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#00142D",
    transform: "translate(10.409091, 9.500000) rotate(-270.000000) translate(-10.409091, -9.500000) ",
    points: "10.4090909 6 15.8181818 13 5 13"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFleetRTcollapseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fleet_RTcollapse_icon.06c36d7967488689f14a89e35bcf1cdd.svg";